import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Blogimg from "./pages/home/blogimg.png";
import Blogimg1 from "./pages/home/blogimg1.png";
import Blogimg2 from "./pages/home/blogimg2.png";
import Blogimg3 from "./pages/home/blogimg3.png";
import Home from "./pages/home/Home";
import Contact from "./pages/contact/Contact";
import About from "./pages/about/About";
import Insights from "./pages/insights/Insights";
import Services from "./pages/services/Services";
import BlogDetail from "./pages/Blog/BlogDetail";
import Services1 from "./pages/services/Services1";
import Services2 from "./pages/services/Services2";
import Services3 from "./pages/services/Services3";
import Services4 from "./pages/services/Services4";
import Services5 from "./pages/services/Services5";
import Services6 from "./pages/services/Services6";
import OurWorkingAreas from "./pages/services/OurWorkingAreas";
import Jobs from "./pages/jobs/Jobs";
import Dashboard from "./pages/dashboard/Dashboard";
import Viewjobs from "./pages/dashboard/Viewjobs";
import ViewjobsCandidates from "./pages/dashboard/ViewjobsCandidates";
import Createjob from "./pages/dashboard/Createjob";
import Candidate from "./pages/dashboard/Candidate";
import Analytics from "./pages/dashboard/Analytics";
import PrivacyPolicy from "./pages/ourPP/PrivacyPolicy";
import TermsAndConditions from "./pages/ourPP/TermsAndConditions";
import Login from "./pages/login/Login";
import CV from "./pages/cv/Cv";
import Fixedsidebar from "./pages/fixedsidebar/Fixedsidebar";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

function App() {
  const ProtectedRoute = ({ children }) => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    console.log("user", user);
    // const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      return <Navigate to="/login" />;
    }
    if (user && user.Username === "abc") {
      return children;
    } else {
      return <Navigate to="/login" />;
    }
  };
  // const BreadcrumbsProvider = ({ children }) => (
  //   <Context.Provider value={useBreadcrumbsHoc()}>
  //     {children}
  //   </Context.Provider>
  // );
  const blogs = [
    {
      img: Blogimg,
      title: "Udaya Solution establishment",
      date: "Jan 26, 2025",
      author: "BISWA RANJAN DAS",
      description:
        "Udaya Solution established in 2007, passion to match the right people to the right job has helped us to amass over a decade of successful stories in the human resource business. Each client and candidate is like an extended family member to us. And like family, we understand and anticipate your needs, matching the right candidates to the right clients. Our professionalism, coupled with a strong personal touch enhances the probability of success at every step. Our goal is to create a long-lasting client-candidate relationship, which will translate into long term winning strategies and exponential growth for both parties. At Udaya Solution, we understand that overall chemistry between the candidate and the existing management is paramount in ensuring a good match. To ensure success, we believe in hiring people with the right values and specialized experience. If you wish to find out more or engage our manpower solution, please do not hesitate to contact us. We look forward to serve you in our professional journey.",
    },
    {
      img: Blogimg1,
      title: "World of Wander Discovering Diverse Landscapes",
      date: "October 19, 2024",
      author: "Meetalii Sahoo",
      description:
        "Embarking on a new professional chapter is both an exciting and transformative experience. As I navigate this transition, I am eager to embrace the opportunities ahead, expand my skill set, and contribute meaningfully to my team and organization. Every day presents new challenges and learning moments, and I am genuinely excited about the growth and possibilities that lie ahead.",
    },
    {
      img: Blogimg2,
      title: "Search of Serenity Tranquil Retreats and Escapes",
      date: "October 19, 2024",
      author: "Abhinash Patanayak",
      description:
        "My journey with Udaya Solution Pvt Ltd began on October 1st, 2022, marking the start of an incredibly rewarding experience. From the very first day, I was welcomed into an environment defined by collaboration, support, and a shared commitment to excellence. What stood out to me immediately was the company's dedication to fostering employee growth, driving innovation, and ensuring customer satisfaction. These values are not just words but are deeply embedded in the organization's culture. Throughout my time here, I have had the privilege of working on challenging and impactful projects that have pushed me to grow both professionally and personally. These experiences have honed my skills, broadened my perspective, and allowed me to contribute meaningfully to our goals. One of the most significant aspects of my journey has been the opportunity to learn from seasoned professionals. Their guidance, mentorship, and willingness to share knowledge have been instrumental in shaping my expertise in recruitment, while also refining my communication, teamwork, and problem-solving abilities. Udaya Solution has provided me with an ideal platform to evolve, learn, and thrive. I am genuinely excited about the road ahead and remain committed to contributing to the company's ongoing growth and success.",
    },
    {
      img: Blogimg3,
      title: "Road to Adventure Embarking on New Horizons",
      date: "October 19, 2024",
      author: "Jyoti Agarwal",
      description:
        "Joining Udaya Solution as Senior Manager – PR and Liaison has been an extraordinary journey of growth and discovery. Here, authenticity and brilliance are celebrated, transforming potential into excellence. This platform has not only refined my skills but has also inspired a deeper alignment of passion with purpose. Udaya Solution is a place where ambition meets opportunity, creating a sanctuary for Unparalleled success.",
    },
  ];
  return (
    <div className="App">
      <BrowserRouter>
        <Fixedsidebar />
        <Routes>
          <Route path="/">
            <Route index element={<Home blogs={blogs} />} />
            <Route path="contact" element={<Contact />} />
            <Route path="about" element={<About />} />
            <Route path="insights" element={<Insights />} />
            {/* <Route path="/" element={<BlogList blogs={blogs} />} /> */}
            <Route
              path="/blog/:blogId"
              element={<BlogDetail blogs={blogs} />}
            />
            <Route path="services" element={<Services />} />
            <Route
              path="Services/Strategic_Staffing_Solution"
              element={<Services1 />}
            />
            <Route path="Services/Executive_Hiring" element={<Services2 />} />
            <Route path="Services/Market_Research" element={<Services3 />} />
            <Route path="Services/Survey" element={<Services4 />} />
            <Route
              path="Services/Training_&_Development"
              element={<Services5 />}
            />
            <Route
              path="Services/HR_Business_Benchmarking"
              element={<Services6 />}
            />
            <Route path="OurWorkingAreas" element={<OurWorkingAreas />} />
          </Route>
          <Route path="/jobs">
            <Route index element={<Jobs />} />
            <Route path="cv/:id" element={<CV />} />
          </Route>
          <Route path="/privacyPolicy">
            <Route index element={<PrivacyPolicy />} />
          </Route>
          <Route path="/TermsAndConditions">
            <Route index element={<TermsAndConditions />} />
          </Route>
          <Route path="/dashboard">
            <Route
              index
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="create_job"
              element={
                <ProtectedRoute>
                  <Createjob />
                </ProtectedRoute>
              }
            />
            <Route
              path="view_jobs/:job_id"
              element={
                <ProtectedRoute>
                  <Viewjobs />
                </ProtectedRoute>
              }
            />
            <Route
              path="view_jobs_candidates/:job_id"
              element={
                <ProtectedRoute>
                  <ViewjobsCandidates />
                </ProtectedRoute>
              }
            />
            <Route
              path="view_candidate/:user_id/:job_id"
              element={
                <ProtectedRoute>
                  <Candidate />
                </ProtectedRoute>
              }
            />
            <Route
              path="analytics"
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="/login">
            <Route index element={<Login />} />
          </Route>
        </Routes>
        {/* </BreadcrumbsProvider> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
